import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { pillarArticles, type ArticleLocale } from "@/mocks/articles";

function getLocale(lang: string, locales: { en: ArticleLocale; fr: ArticleLocale; da: ArticleLocale; de: ArticleLocale }): ArticleLocale {
  const key = lang.split("-")[0] as "en" | "fr" | "da" | "de";
  return locales[key] || locales.en;
}

export default function PillarArticles() {
  const { t, i18n } = useTranslation();

  return (
    <section id="articles" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("pillars.title")}</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl mx-auto">{t("pillars.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {pillarArticles.map((article) => {
            const locale = getLocale(i18n.language, article.locales);
            return (
              <Link
                key={article.slug}
                to={`/articles/${article.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors overflow-hidden"
              >
                <div className="w-full h-44 md:h-48 overflow-hidden bg-background-100">
                  <img
                    src={article.image}
                    alt={locale.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col flex-1 p-5">
                  <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                    <span className="inline-flex items-center gap-1 text-primary-600">
                      <i className="ri-bookmark-line"></i>
                    </span>
                    <span>
                      {article.readTime} {t("pillars.minRead")}
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                    {locale.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-2 flex-1">{locale.description}</p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    {t("pillars.readMore")}
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}